import React from 'react';
import { IconProps } from './model/IconInterface';

const PointerIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z" /><line x1="13" y1="13" x2="19" y2="19" />
    </svg>
  );
};

export default PointerIcon;
